import { useI18n } from 'hooks/useI18n';
import React from 'react';
import styled from 'styled-components';
import { fontSize, fontWeight, radius } from 'theme';

interface FeaturedVideoProps {
  videoId: string;
}

const getYouTubeVideoId = (url: string): string | null => {
  const regExp =
    // eslint-disable-next-line no-useless-escape
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};

const VideoCard = styled.div`
  background-color: #f7f2df;
  overflow: hidden;
  text-align: left;
`;

const VideoTitle = styled.div`
  font-size: clamp(${fontSize('xs')}, 2.2vw, ${fontSize('md')});
  font-weight: ${fontWeight('black')};
  color: #2d2d2d;
  display: flex;
  align-items: flex-end;
  height: 4rem;
`;

const VideoEmbedContainer = styled.div`
  position: relative;
  width: 100%;

  padding-bottom: 177.78%; /* 16:9 Aspect Ratio */
  background-color: #000;
  border-radius: ${radius('full')};

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
    border-radius: ${radius('lg')};
    object-fit: fill;
  }
`;

// Reusable FeaturedVideo Component
export const FeaturedVideo: React.FC<FeaturedVideoProps> = ({ videoId }) => {
  const { t } = useI18n('landing-septiembre25');
  const videoTitle = t(`videos.video-${videoId}.title`);
  const videoUrl = t(`videos.video-${videoId}.url`);
  const youtubeId = getYouTubeVideoId(videoUrl);

  if (!youtubeId) {
    return null;
  }

  return (
    <VideoCard>
      <VideoTitle>{videoTitle}</VideoTitle>
      <VideoEmbedContainer>
        <iframe
          src={`https://www.youtube.com/embed/${youtubeId}`}
          title={videoTitle}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </VideoEmbedContainer>
    </VideoCard>
  );
};
